import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Нежный, комфортный, тёплый футер внутри и хлопок снаружи.<br/>Стильный фасон. Маленькие размеры приталенные.<br/>Яркие краски, которые не выцветают и не смываются.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_woman_sweatshirt`],
      sizeInfo: `full_print_woman_sweatshirt`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
